/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import {service as ContactMethodService} from "../../../Services/ContactMethodService";
import autobind from "autobind-decorator";
import {FormControl} from "react-bootstrap";
import React from "react";

export class ContactMethodFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)

		this.setInitialState({
			contactMethods: []
		});
	}

	componentDidMount() {
		ContactMethodService.Get()
			.then((x) => {
				this.setState({contactMethods: x.result});
			});
	}

	@autobind
	_render() {
		return <FormControl
			as="select"
			placeholder="Select A Contact Method"
			value={this.props.Value != null ? this.props.Value : ""}
			onChange={(x) => this.props.OnUpdate(x.target.value)}
		>
			<option value="">Select A Contact Method</option>
			{
				this.state.contactMethods.map((x) => <option key={x.contactMethodId}
				                                             value={x.contactMethodId}>{x.name}</option>)
			}
		</FormControl>;
	}
}